import { VtoProduct } from "@hermes/api-model-virtual-try-on";
import {
    AnalyticsEvent,
    GTMEcommerceData,
    NO_SIZE,
    PRODUCT_AVAILABILITY_STATUS_ECOM,
    PRODUCT_IN_STOCK,
} from "@hermes/utils/analytics";
import { Currency } from "@hermes/locale";
import { BRAND } from "@hermes/utils-generic/constants";

const PERFECT_PARTNER = "perfect_partner";
const PERSONALIZE = "no";
/**
 * This class is used for learn more event in vto modal
 */
export class LearnMoreClickEvent implements AnalyticsEvent<GTMEcommerceData> {
    /**
     * Event name expected for every productClick event
     */
    public name: string = "productClick";
    /**
     * Event's data from component to format correctly product-click event
     */
    public eventData!: {
        product: VtoProduct;
        index: number;
        currency: Currency;
    };

    constructor(eventData: {
        product: VtoProduct;
        index: number;
        currency: Currency;
    }) {
        this.eventData = eventData;
    }

    /**
     * Overload formatForGTM of inherited class
     * Return formatter for ecommerce key
     */
    public formatForGTM(): GTMEcommerceData {
        return {
            event: this.name,
            ecommerce: {
                currencyCode: this.eventData.currency,
                click: {
                    products: [this.getProductData(this.eventData.product)],
                    actionField: {
                        list: PERFECT_PARTNER,
                    },
                },
            },
        };
    }

    /**
     * Formatter for product
     *
     * @param product product clicked
     */
    private getProductData = (product: VtoProduct) => ({
        name: product.title,
        id: product.sku,
        price: product.price.toFixed(2),
        brand: BRAND,
        category: `${product.departmentCode}/${product.familyCode}`,
        variant: product.variant || undefined,
        position: this.eventData.index + 1,
        // eslint-disable-next-line unicorn/explicit-length-check
        dimension5: product.size || NO_SIZE,
        dimension6: product.departmentCode,
        dimension7: product.familyCode,
        dimension8: product.productCode,
        dimension9: product.divisionCode,
        dimension37: PRODUCT_IN_STOCK,
        dimension52: PERSONALIZE,
        dimension53: PRODUCT_AVAILABILITY_STATUS_ECOM,
    });
}
